module.exports = __webpack_public_path__ + "media/metronic/_theme/media/company-logos/logo_invoice_white-6ea2ea0f3e5f5d5cf7c3126ea693c66c.png";